import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5bf318a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "empty-state text-center py-8 px-4"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-body-2" }, "Még nincs tétel az ajánlatban", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Töltse ki a fenti űrlapot, majd nyomja meg a „Tétel hozzáadása” gombot.", -1))
const _hoisted_4 = { class: "font-weight-medium" }
const _hoisted_5 = {
  key: 0,
  class: "text-caption text-medium-emphasis"
}
const _hoisted_6 = { class: "text-caption text-medium-emphasis" }
const _hoisted_7 = { class: "font-weight-medium" }
const _hoisted_8 = { class: "totals pa-4" }
const _hoisted_9 = {
  class: "d-flex justify-end flex-wrap",
  style: {"gap":"32px"}
}
const _hoisted_10 = { class: "total-block" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Bejövő összesen", -1))
const _hoisted_12 = { class: "text-body-1" }
const _hoisted_13 = { class: "total-block" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Kimenő nettó összesen", -1))
const _hoisted_15 = { class: "text-h6" }
const _hoisted_16 = { class: "total-block" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Árrés", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "offer-lines-card",
    variant: "outlined"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_toolbar, {
        flat: "",
        height: "48",
        color: "transparent"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_toolbar_title, { class: "text-subtitle-1 font-weight-medium" }, {
            default: _withCtx(() => [
              _createTextVNode("Ajánlat tételei")
            ]),
            _: 1
          }),
          _createVNode(_component_v_spacer),
          ($props.items.length > 0)
            ? (_openBlock(), _createBlock(_component_v_chip, {
                key: 0,
                size: "small",
                variant: "tonal"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($props.items.length) + " tétel", 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider),
      ($props.items.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              class: "mb-2",
              icon: "mdi-table-plus",
              size: "32",
              color: "grey"
            }),
            _hoisted_2,
            _hoisted_3
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_v_data_table, {
              class: "offer-lines-table",
              items: $setup.rows,
              headers: $setup.headers,
              "hide-default-footer": true,
              density: "comfortable",
              hover: ""
            }, {
              "item.accommodation": _withCtx(({ item }) => [
                _createElementVNode("div", _hoisted_4, _toDisplayString(item.accommodation), 1),
                (item.city)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(item.city), 1))
                  : _createCommentVNode("", true)
              ]),
              "item.period": _withCtx(({ item }) => [
                _createElementVNode("div", null, _toDisplayString(item.from) + " – " + _toDisplayString(item.to), 1),
                _createElementVNode("div", _hoisted_6, _toDisplayString(item.nights) + " éj", 1)
              ]),
              "item.grossPricePerPersonPerNight": _withCtx(({ item }) => [
                _createTextVNode(_toDisplayString($setup.formatHuf(item.grossPricePerPersonPerNight)), 1)
              ]),
              "item.retailPrice": _withCtx(({ item }) => [
                _createTextVNode(_toDisplayString($setup.formatHuf(item.retailPrice)), 1)
              ]),
              "item.marginPerPersonPerNight": _withCtx(({ item }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(item.marginPerPersonPerNight <= 0 ? 'text-error font-weight-medium' : '')
                }, _toDisplayString($setup.formatHuf(item.marginPerPersonPerNight)), 3)
              ]),
              "item.revenue": _withCtx(({ item }) => [
                _createElementVNode("div", _hoisted_7, _toDisplayString($setup.formatHuf(item.revenue)), 1)
              ]),
              "item.actions": _withCtx(({ item }) => [
                _createVNode(_component_v_btn, {
                  icon: "mdi-pencil-outline",
                  variant: "text",
                  size: "small",
                  density: "comfortable",
                  onClick: ($event: any) => ($setup.editItem(item.index))
                }, null, 8, ["onClick"]),
                _createVNode(_component_v_btn, {
                  icon: "mdi-delete-outline",
                  variant: "text",
                  size: "small",
                  density: "comfortable",
                  color: "error",
                  onClick: ($event: any) => ($setup.removeItem(item.index))
                }, null, 8, ["onClick"])
              ]),
              bottom: _withCtx(() => []),
              _: 1
            }, 8, ["items"]),
            _createVNode(_component_v_divider),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, _toDisplayString($setup.formatHuf($setup.totals.cost)), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, _toDisplayString($setup.formatHuf($setup.totals.revenue)), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", {
                    class: _normalizeClass(["text-body-1", $setup.totals.margin <= 0 ? 'text-error font-weight-bold' : 'text-success font-weight-medium'])
                  }, _toDisplayString($setup.formatHuf($setup.totals.margin)) + " (" + _toDisplayString($setup.totals.marginPercent.toFixed(1)) + "%)", 3)
                ])
              ])
            ]),
            ($setup.totals.margin <= 0)
              ? (_openBlock(), _createBlock(_component_v_alert, {
                  key: 0,
                  class: "mx-4 mb-4",
                  type: "error",
                  variant: "tonal",
                  density: "compact"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Az ajánlaton nincs árrés – a kimenő ár nem haladja meg a bejövő árat.")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 64))
    ]),
    _: 1
  }))
}